import { LocaleMatch } from '../routes';
import { ClientSafeTenant } from '../../../helpcenter-data';
import { helpcenterApi } from '../../../api';

export const searchArticleResults = (
  locale: string,
  searchTerm: string,
  baseUrl?: string,
) =>
  helpcenterApi
    .searchArticles(
      {
        locale,
        text: searchTerm,
        page: 1,
        pageSize: 20,
        spellcheck: true,
      },
      baseUrl,
    )
    .then((articleList) => ({
      articles: articleList,
      search: {
        term: searchTerm,
      },
    }));

const loadDataClient = (
  params: LocaleMatch,
  tenant: ClientSafeTenant,
  location: any,
) =>
  Promise.all([
    searchArticleResults(
      params.locale,
      new URLSearchParams(location.search).get('term') || '',
    ),
  ]);

export default loadDataClient;
